import Vue from 'vue'
import Router from 'vue-router'

//组件模块
import index from './components/index'
import secondPage from './components/secondPage'
import fourthPage from './components/fourthPage'
import gaokao from './components/gaokao'
import gaokaopre from './components/gaokaopre'
import gaokaoafter from './components/gaokaoafter'
import write from './components/write'
import inputname from './components/inputName'
import share from './components/sharePage'
 
Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'index', component: index },
    { path: '/second', name: 'secondPage', component: secondPage },
    { path: '/four', name: 'fourthPage', component: fourthPage },
    { path: '/gaokao', name: 'gaokao', component: gaokao },
    { path: '/gaokaopre', name: 'gaokaopre', component: gaokaopre },
    { path: '/gaokaoafter', name: 'gaokaoafter', component: gaokaoafter },
    { path: '/write', name: 'write', component: write },
    { path: '/inputname', name: 'inputname', component: inputname },
    { path: '/share', name: 'share', component: share }
  ]
})